import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminApi, ADMIN_PATH } from '../services/adminApi';
import './AdminLogin.css';

export const AdminLogin: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('admin_token')) {
      navigate(`/${ADMIN_PATH}/dashboard`, { replace: true });
    }
  }, [navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await adminApi.login(username, password);
      if (data.success && data.token) {
        localStorage.setItem('admin_token', data.token);
        navigate(`/${ADMIN_PATH}/dashboard`, { replace: true });
      }
    } catch (err: any) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="al-root">
      <div className="al-card">
        <div className="al-logo">
          <span className="al-logo-icon">⬡</span>
          <span className="al-logo-text">GTA Rental</span>
        </div>
        <h1 className="al-title">Platform Console</h1>
        <p className="al-sub">Restricted access — authorised personnel only</p>

        <form className="al-form" onSubmit={handleSubmit}>
          <div className="al-field">
            <label className="al-label">Username</label>
            <input
              className="al-input"
              type="text"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              disabled={loading}
              required
            />
          </div>
          <div className="al-field">
            <label className="al-label">Password</label>
            <input
              className="al-input"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
              required
            />
          </div>
          {error && <p className="al-error">{error}</p>}
          <button className="al-btn" type="submit" disabled={loading || !username || !password}>
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
};
